/** @format */

import React, {FC} from "react";
import {StyleSheet, TouchableOpacity, View,} from "react-native";
import ShareIcon from "../Icons/ShareIcon";
import {Frame, IsMobile} from "../theme";
import {AppTheme, useTheme} from "../theme/colors";

interface HeaderProps {
    children: JSX.Element;
    onPressShare?: () => void;
    Icon?: JSX.Element;
    showShareIcon?: boolean;
}

const HeaderWrap: FC<HeaderProps> = ({
                                         children,
                                         Icon,
                                         onPressShare,
                                         showShareIcon = true,
                                     }) => {
    const theme = useTheme();
    const styles = getStyles(theme);

    return (
      <View
        style={[
            {
                flex: 1,
                position: "relative",
                backgroundColor: theme.BACKGROUND,
            },
            !IsMobile && {width: Frame.width, alignSelf: "center"},
        ]}
      >
          <View style={styles.header}>
              {/* Outer Transparent Circle */}
              <View style={styles.outerCircle}>
                  {/* Inner Solid Circle */}
                  <View style={[styles.innerCircle, !IsMobile && styles.containerDesktop]}>
                      <View style={styles.iconContainer}>{Icon}</View>
                  </View>
              </View>
          </View>

          {children}

          {showShareIcon && (
            <View style={styles.shareButtonContainer}>
                <TouchableOpacity
                  onPress={onPressShare}
                  style={styles.shareButton}
                >
                    <ShareIcon
                      color={theme.ACCENT}
                      width={30}
                      height={30}
                    />
                </TouchableOpacity>
            </View>
          )}
      </View>
    );
};

export default HeaderWrap;

const pos = Frame.width < 350 ? 3 : Frame.width < 380 ? 3.7 : 4.5;
const pl = Frame.width > 410 ? (Frame.height > 850 ? 6 : 6.5) : 5.5;
const pb = Frame.width > 410 ? 7 : 6;

const getStyles = (theme: AppTheme) =>
  StyleSheet.create({
      header: {
          position: "absolute",
          top: 0,
          right: -10,
          width: 50,
          height: 50,
          zIndex: 200
      },

      // Outer circle (240px) - Half Transparent
      outerCircle: {
          backgroundColor: "rgba(249, 157, 57, 0.1)", // 50% transparent orange
          width: 220,
          height: 220,
          borderRadius: 120, // Perfect circle
          position: "absolute",
          top: -(Frame.width / pos) - 10, // Adjust to fit
          right: -(Frame.width / pos) - 10, // Adjust to fit
          alignItems: "center",
          justifyContent: "center",
      },

      // Inner Circle (220px) - Solid
      innerCircle: {
          backgroundColor: "#f99d39",
          width: 180,
          height: 180,
          borderRadius: 110, // Perfect inner circle
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
      },

      // Moves the Icon 40px left & 40px down
      iconContainer: {
          transform: [{translateX: -25}, {translateY: 25}],
      },

      containerDesktop: {
          width: 120,
          height: 120,
          paddingLeft: 60,
          paddingBottom: 40,
          top: -30,
          zIndex: 1,
      },

      title: {
          fontSize: 22,
          fontWeight: "600",
          width: "65%",
      },

      shareButton: {
          width: 50,
          height: 50,
          backgroundColor: theme.BACKGROUND,
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 50,
          shadowColor: theme.LIGHT_GREY,
          shadowOffset: {width: 3, height: 3},
          shadowOpacity: 0.3,
          shadowRadius: 10,
      },

      shareButtonContainer: {
          position: "absolute",
          bottom: 60,
          right: IsMobile ? 20 : -(Frame.width / 3.2),
      },
  });